import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const KEY = "claim-popup-dismissed";
const DAY = 24 * 60 * 60 * 1000;
const PRIVATE = /^\/(admin|dashboard|sales|agent|profile|webadvisor|call-center|prospect-dialer|conference|meet|watch|podcast\/record|demo\/app|demo-|onboarding-show|client|careers\/portal|claim|login|register|set-password|shop\/|business|p\/|invoice|q\/|lp\/)/;

export const ClaimPopup = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const eligible = !PRIVATE.test(pathname) && !["admin", "sales_rep"].includes(user?.role);

  useEffect(() => {
    if (!eligible || Date.now() - Number(localStorage.getItem(KEY) || 0) < DAY) return;
    const t = setTimeout(() => setOpen(true), 5000);
    return () => clearTimeout(t);
  }, [eligible, pathname]);

  const close = () => { localStorage.setItem(KEY, String(Date.now())); setOpen(false); };
  if (!open || !eligible) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 animate-in fade-in duration-300" onClick={close} data-testid="claim-popup-overlay">
      <div className="relative w-full max-w-[750px] animate-in zoom-in-95 duration-300" onClick={(e) => e.stopPropagation()} data-testid="claim-popup">
        <Link to="/claim-your-page" onClick={close} data-testid="claim-popup-cta">
          <img src="/brand/claim-popup.gif" alt="Claim your page on The ShopAdvisor Directory" className="w-full h-auto rounded-2xl shadow-2xl" />
        </Link>
        <button onClick={close} aria-label="Close" className="absolute right-[0.5%] top-[0.5%] w-[9%] aspect-square rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-testid="claim-popup-close" />
      </div>
    </div>
  );
};
